import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Content,
  NavDrawer,
  NavDrawerTitle,
  NavDrawerList,
  NavDrawerListItem,
  PageInfo,
  TopBar,
} from '@redshelf/redshelf-ui';
import { Account } from '@redshelf/redshelf-data';

import { Box, Hidden, IconButton, Link } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';

import Error403 from 'views/errors/403';

import { AccountMenu, Logo } from 'components';
import { ROUTER } from 'constants';

import AssessmentIcon from '@material-ui/icons/Assessment';
import BookIcon from '@material-ui/icons/Book';
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks';
import RecentActorsIcon from '@material-ui/icons/RecentActors';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import TableChartIcon from '@material-ui/icons/TableChart';

const environment = process.env.REACT_APP_NODE_ENV || process.env.NODE_ENV;
const isProduction = environment === 'production';

const accountService = new Account();

const DefaultLayout = ({ children }) => {
  const [isMobileNavOpen, setMobileNavOpen] = useState(false);

  const { is_logged_in: isLoggedIn } = accountService.user || {};

  const canAccess =
    !isProduction || accountService.canUserAccessCampusInsights();

  if (!isLoggedIn) {
    const redirectRoute = ROUTER.basename;
    const defaultURL = isProduction
      ? document.location.origin
      : 'http://localhost:8000';
    const redirectURL = isProduction
      ? redirectRoute
      : `${document.location.origin}${redirectRoute}`;

    document.location.href = `${defaultURL}/accounts/login/?next=${redirectURL}`;
    return null;
  }

  const handleMobileOnOpen = () => {
    setMobileNavOpen(true);
  };

  const handleMobileOnClose = () => {
    setMobileNavOpen(false);
  };

  return (
    <Content isRoot>
      <PageInfo defaultTitle="Campus Insights" />
      {/* TODO: Move more of the "TopBar" content to RSUI... */}
      <TopBar>
        <Hidden lgUp>
          <IconButton onClick={handleMobileOnOpen}>
            <MenuIcon fontSize="small" />
          </IconButton>
        </Hidden>
        <Hidden mdDown>
          <Link
            component="button"
            aria-label={`logo, go to ${document.location.origin}`}
            onClick={() => {
              window.location.href = document.location.origin;
              return;
            }}
          >
            <Logo height="32" />
          </Link>
        </Hidden>
        <Box ml={2} flexGrow={1} />
        <Box ml={2}>
          <AccountMenu />
        </Box>
      </TopBar>
      <NavDrawer
        mobileProps={{
          isOpen: isMobileNavOpen,
          onClose: handleMobileOnClose,
        }}
      >
        <NavDrawerTitle icon={<AssessmentIcon />} title="Campus Insights" />
        <NavDrawerList>
          <NavDrawerListItem
            to={`${ROUTER.basename}/section`}
            icon={<BookIcon />}
            label="Sections"
          />
          <NavDrawerListItem
            to={`${ROUTER.basename}/participant`}
            icon={<RecentActorsIcon />}
            label="Participants"
          />
        </NavDrawerList>
        <NavDrawerList subheader="Reporting">
          <NavDrawerListItem
            to={`${ROUTER.basename}/materials_summary`}
            icon={<LibraryBooksIcon />}
            label="Materials Summary"
          />
          <NavDrawerListItem
            to={`${ROUTER.basename}/utilization_summary`}
            icon={<VpnKeyIcon />}
            label="Utilization Summary"
          />
        </NavDrawerList>
        {canAccess && (
          <NavDrawerList subheader="Legacy Tools">
            <NavDrawerListItem
              href={`${document.location.origin}/campus/inclusive/`}
              icon={<TableChartIcon />}
              label="Inclusive Access"
            />
          </NavDrawerList>
        )}
      </NavDrawer>
      <Content>{canAccess ? children : <Error403 />}</Content>
    </Content>
  );
};

DefaultLayout.propTypes = {
  /**
   * Your component tree.
   */
  children: PropTypes.node,
};

export default DefaultLayout;
